import type { Segment, SegmentsClientInterface } from './segmentsClient.types';
import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { QueryParams } from '~/services/api';

export default class GroupSegmentsClient extends BaseClient implements SegmentsClientInterface {
    constructor(private teamId: number, private groupId: string) {
        super();
    }

    getSegments(params?: QueryParams, config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/segments`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getSegmentsCount(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/segments/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    createSegment(segment: Segment) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/segments`;
        return this.makeCoreApiRequest(url, 'post', segment);
    }

    getSegment(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateSegment(segmentId: number, segment: Segment) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'put', segment);
    }

    deleteSegment(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getSegmentsContactsCount(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/segments/contact-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }
}
